import utils from "./index.js"
export default {
  goodTime(str) {
    let now = new Date().getTime()
    let oldTime = new Date(str).getTime()
    let difference = now - oldTime
    let result = ''
    let minute = 1000 * 60
    let hour = minute * 60
    let day = hour * 24
    let month = day * 30
    let year = month * 12
    let _year = difference / year
    let _month = difference / month
    let _week = difference / (7 * day)
    let _day = difference / day
    let _hour = difference / hour
    let _min = difference / minute

    if (_year >= 1) {
      result = '发表于 ' + ~~(_year) + ' 年前'
    } else if (_month >= 1) {
      result = '发表于 ' + ~~(_month) + ' 个月前'
    } else if (_week >= 1) {
      result = '发表于 ' + ~~(_week) + ' 周前'
    } else if (_day >= 1) {
      result = '发表于 ' + ~~(_day) + ' 天前'
    } else if (_hour >= 1) {
      result = '发表于 ' + ~~(_hour) + ' 个小时前'
    } else if (_min >= 1) {
      result = '发表于 ' + ~~(_min) + ' 分钟前'
    } else {
      result = '刚刚'
    }
    return result
  },
  //检查是不是两位数字，不足补全
  checkDate(str) {
    str = str.toString();
    if (str.length < 2) {
      str = '0' + str;
    }
    return str;
  },
  getTimeFomat(date, str) {
    if(typeof date === 'string'){
       date=new Date(date);
    }
    var mat = {};
    mat.M = date.getMonth() + 1;//月份记得加1 
    mat.H = date.getHours();
    mat.s = date.getSeconds();
    mat.m = date.getMinutes();
    mat.Y = date.getFullYear();
    mat.D = date.getDate();
    mat.d = date.getDay();//星期几
    mat.d = this.checkDate(mat.d);
    mat.H = this.checkDate(mat.H);
    mat.M = this.checkDate(mat.M);
    mat.D = this.checkDate(mat.D);
    mat.s = this.checkDate(mat.s);
    mat.m = this.checkDate(mat.m);
    // console.log(typeof mat.D)
    let dateStr = "";
    if (str === "yyyy-mm-dd hh:MM:ss") {
      dateStr = mat.Y + "-" + mat.M + "-" + mat.D + " " + mat.H + ":" + mat.m + ":" + mat.s;
    } else if (str === "yyyy-mm") {
      dateStr = mat.Y + "-" + mat.M
    }else if (str === "yyyy-mm-dd hh") {
      dateStr = mat.Y + "-" + mat.M + "-" + mat.D + " " + mat.H;
    } else if (str === "yyyy-mm-dd") {
      dateStr = mat.Y + "-" + mat.M + "-" + mat.D;
    } else if (str === "yyyy+1-mm-dd") {
      dateStr = mat.Y + 1 + "-" + mat.M + "-" + mat.D;
    } else if (str === "hh:MM") {
      dateStr = mat.H + ":" + mat.m;
    } else if (str.indexOf(":") > -1) {
      mat.Y = mat.Y.toString().substr(2, 2);
      dateStr = mat.Y + "-" + mat.M + "-" + mat.D + " " + mat.H + ":" + mat.m + ":" + mat.s;
    } else if (str.indexOf("/") > -1) {
      dateStr = mat.Y + "/" + mat.M + "/" + mat.D + " " + mat.H + "/" + mat.m + "/" + mat.s;
    } else if (str.indexOf("-") > -1) {
      dateStr = mat.Y + "-" + mat.M + "-" + mat.D + " " + mat.H + "-" + mat.m + "-" + mat.s;
    }
    return dateStr;
  },
  //检查是不是两位数字，不足补全
  check(str) {
    str = str.toString();
    if (str.length < 2) {
      str = '0' + str;
    }
    return str;
  },
  //获取两个日期时间间隔
  getDateDiff(startDate, endDate) {
    var startTime = new Date(
      Date.parse(startDate.replace(/-/g, "/"))
    ).getTime();
    var endTime = new Date(Date.parse(endDate.replace(/-/g, "/"))).getTime();
    var dates = Math.abs(startTime - endTime) / (1000 * 60 * 60 * 24);
    return dates;
  },
  getDay(day) {
    let today = new Date();
    let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
    today.setTime(targetday_milliseconds); //注意，这行是关键代码
    let tYear = today.getFullYear();
    let tMonth = today.getMonth();
    let tDate = today.getDate();
    tMonth = this.doHandleMonth(tMonth + 1);
    tDate = this.doHandleMonth(tDate);
    return tYear + "-" + tMonth + "-" + tDate;
  },
  doHandgetDay(day) {
    let today = new Date();
    let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
    today.setTime(targetday_milliseconds); //注意，这行是关键代码
    let tYear = today.getFullYear();
    let tMonth = today.getMonth();
    let tDate = today.getDate();
    tMonth = this.doHandleMonth(tMonth + 1);
    tDate = this.doHandleMonth(tDate);
    return tYear + "-" + tMonth + "-" + tDate;
  },
  doHandleMonth(month) {
    let m = month;
    if (month.toString().length == 1) {
      m = "0" + month;
    }
    return m;
  },
  /**
   * 转换成Date类型。
   *
   *     // return "2014-01-01T16:00:00.000Z"
   *     parse("2014/01/02").toISOString()
   *     // return "2014-01-01T16:00:00.000Z"
   *     parse("2014/01/02", "yyyy/MM/dd").toISOString()
   * @param {string|number} value 字符或数值或number类型
   * @param {string} [format] 转换格式
   * 当value为字符串类型时，如果不提供，则尽可能按常见格式去解析，
   * 常见格式为yyyy[/-]MM[/-]dd hh:mm:ss.SSS， MM[/-]dd [/-]yyyy hh:mm:ss.SSS及ISO8601时间格式。
   * 如果提供，则按具体格式严格匹配解析，并且年份必须为4位。
   *
   *  - yyyy代表年份，M或MM代表1位或2位的月份
   *  - d或dd代表1位或2位的天数
   *  - h或hh表示24小时的1位或2位的小时
   *  - m或mm代表1位或2位的分钟，
   *  - s或s代表1位或2位的秒
   *  - S或SS或SSS代表1位或2位或3位的毫秒
   * @param {string} [minDate] 最小时间，默认为0001-01-01 00:00:00.000
   *
   * @returns {Date} 日期对象
   *
   *
   */
  parse(value, format, minDate) {
    var d1;
    if (utils.isNumber(value)) {
      d1 = new Date(value * 1);
    } else if (utils.isString(value)) {
      d1 = innerParse(value, format);
    }

    if (minDate) {
      var d2 = (minDate && this.parse(minDate)) || new Date(1, 1, 1, 0, 0, 0);
      return (d1 && d1 < d2) ? d2 : d1;
    }

    return d1;
  },
  /**
   * @param value 字符或数值或number类型
   * @param format 转换格式
   * @param minDate 最小时间
   * @returns {*|Date}
   */
  toDate(value, format, minDate) {
    return this.parse(value, format, minDate);
  },
}







let dateCfg = {
  dateFormatRegs: {
    "y{1,4}": new RegExp("y{1,4}"),
    "M{1,2}": new RegExp("M{1,2}"),
    "d{1,2}": new RegExp("d{1,2}"),
    "h{1,2}": new RegExp("h{1,2}"),
    "m{1,2}": new RegExp("m{1,2}"),
    "s{1,2}": new RegExp("s{1,2}"),
    "S{1,3}": new RegExp("S{1,3}")
  },
  /**
   * maxDateValues
   */
  maxDateValues :{
    YEAR: 9999,
    MONTH: 11,
    DATE: 31,
    HOUR: 23,
    MINUTE: 59,
    SECOND: 59,
    MILLISECOND: 999
  },
  /**
   * daysInMonths
   */
  daysInMonths: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  /**
   * timezones
   */
  timezones: [
    "-12:00", "-11:00", "-10:00", "-09:30", "-08:00", "-07:00", "-06:00", "-05:00", "-04:30",
    "-04:00", "-03:30", "-02:00", "-01:00", "-00:00", "+00:00", "+01:00", "+02:00", "+03:00",
    "+03:30", "+04:00", "+04:30", "+05:00", "+05:30", "+05:45", "+06:00", "+06:30", "+07:00",
    "+08:00", "+09:00", "+10:00", "+10:30", "+11:00", "+11:30", "+12:00", "+12:45", "+13:00", "+14:00"
  ],
  /**
   * yyyymmddReg
   */
  yyyymmddReg: /^(\d{4})(\/|-)(((0)?[1-9])|(1[0-2]))((\/|-)(((0)?[1-9])|([1-2][0-9])|(3[0-1])))?( ((0)?[0-9]|1[0-9]|20|21|22|23):([0-5]?[0-9])((:([0-5]?[0-9]))?(\.([0-9]{1,6}))?)?)?$/,
  /**
   * mmddyyyyReg
   */
  mmddyyyyReg: /^(((0)?[1-9])|(1[0-2]))(\/|-)(((0)?[1-9])|([1-2][0-9])|(3[0-1]))(\/|-)(\d{4})( ((0)?[0-9]|1[0-9]|20|21|22|23):([0-5]?[0-9])((:([0-5]?[0-9]))?(\.([0-9]{1,6}))?)?)?$/,
  /**
   * iso8601Reg
   */
  iso8601Reg: /^(\d{4})-(((0)?[1-9])|(1[0-2]))-(((0)?[1-9])|([1-2][0-9])|(3[0-1]))T(((0)?[0-9]|1[0-9]|20|21|22|23):([0-5]?[0-9])((:([0-5]?[0-9]))?(\.([0-9]{1,6}))?)?)?(Z|([+-])((0)?[0-9]|1[0-9]|20|21|22|23):?([0-5]?[0-9]))$/
}
/**
 * yyyymmddDateParser
 * @param m
 * @returns {Date}
 */
function yyyymmddDateParser(m) {
  if (m.length === 23) {
    var year = m[1] * 1,
      month = m[3] - 1,
      date = (m[9] || 1) * 1,
      hours = m[15] || 0,
      minutes = m[17] || 0,
      seconds = m[20] || 0,
      milliseconds = m[22] || 0,
      daysInMonths = dateCfg.daysInMonths[month];
    if (isLeapYear(year) && month === 1) {
      daysInMonths += 1;
    }

    if (date <= daysInMonths) {
      return new Date(year, month, date, hours, minutes, seconds, milliseconds);
    }
  }
}
/**
 * mmddyyyyDateParser
 * @param m
 * @returns {Date}
 */
function mmddyyyyDateParser(m) {
  if (m.length === 22) {
    var year = m[12] * 1,
      month = m[1] - 1,
      date = (m[6] || 1) * 1,
      hours = m[14] || 0,
      minutes = m[16] || 0,
      seconds = m[19] || 0,
      milliseconds = m[21] || 0,
      daysInMonths = dateCfg.daysInMonths[month];
    if (isLeapYear(year) && month === 1) {
      daysInMonths += 1;
    }

    if (date <= daysInMonths) {
      return new Date(year, month, date, hours, minutes, seconds, milliseconds);
    }
  }
}
/**
 * iso8601DateParser
 * @param m
 * @returns {Date}
 */
function iso8601DateParser(m) {
  if (m.length === 25) {
    var offset = new Date().getTimezoneOffset(),
      year = m[1] * 1,
      month = m[2] - 1,
      date = (m[6] || 1) * 1,
      hours = m[12] || 0,
      minutes = m[14] || 0,
      seconds = m[17] || 0,
      milliseconds = m[19] || 0,
      timeZone = m[20],
      sign = m[21],
      offsetHours = m[22] || 0,
      offsetMinutes = m[24] || 0,
      daysInMonths = dateCfg.daysInMonths[month],
      actHours, actMinutes
    if (isLeapYear(year) && month === 1) {
      daysInMonths += 1
    }
    if (date <= daysInMonths) {
      if (timeZone === 'Z') {
        actHours = hours - offset / 60
        actMinutes = minutes
      } else {
        // 修复 iso8601Reg 不支持 parse('2017-09-08T17:14:23.077+0800') 的格式，原先仅支持 +08:00   m00278660 2018/01/27
        if (timeZone.indexOf(':') === -1) {
          timeZone = timeZone.substr(0, 3) + ':' + timeZone.substr(3)
        }
        if (dateCfg.timezones.indexOf(timeZone) === -1) {
          return;
        }

        actHours = ((sign === "+") ? hours - offsetHours - offset / 60 : hours + offsetHours + offset / 60);
        actMinutes = (sign === "+") ? minutes - offsetMinutes : minutes + offsetMinutes;
      }

      return new Date(year, month, date, actHours, actMinutes, seconds, milliseconds);
    }
  }
}
let dateParsers = [
  [dateCfg.yyyymmddReg, yyyymmddDateParser], //支持年月，如2014-01
  [dateCfg.mmddyyyyReg, mmddyyyyDateParser],
  [dateCfg.iso8601Reg, iso8601DateParser]
];
/**
     * parseDate
     * @param str
     * @returns {*}
     */
function parseDate(str) {
  var i, m;
  for (i = 0; i < this.dateParsers.length; i++) {
    m = this.dateParsers[i][0].exec(str);
    if (m && m.length > 0) {
      return this.dateParsers[i][1].call(this, m);
    }
  }
}
/**
 * getDateArray
 * @param str
 * @param format
 * @returns {number[]}
 */
function getDateArray(str, format) {
  //必须精确匹配
  var arr = [0, -1, 0, 0, 0, 0];
  if (str.length !== format.length) {
    return arr;
  }

  var valuePos = 0,
    textPos = 0,
    len = Math.min(str.length, format.length),
    value,
    text,
    notNum,
    charValue,
    i,
    end;
  for (i = 0; i < len; i++) {
    charValue = str.substr(i, 1);
    notNum = isNaN(charValue * 1) || charValue.trim() === '';

    if ((notNum && charValue === format.substr(i, 1)) || i === len - 1) {
      if (notNum) {
        value = str.substring(valuePos, i);
        valuePos = i + 1;
        end = format.indexOf(charValue, textPos);
        text = format.substring(textPos, (end === -1) ? format.length : end);
        textPos = end + 1;
      } else {
        value = str.substring(valuePos, len);
        text = format.substring(textPos, len);
      }

      if (value.length !== text.length && (!value || !text)) {
        continue;
      }

      matchDateArray(arr, value, text);
    }
  }
  return arr;
}
/**
 * matchDateArray
 * @param arr
 * @param value
 * @param text
 */
function matchDateArray(arr, value, text) {
  if (text) {
    switch (text) {
      case "yyyy":
      case "yy":
        arr[0] = value;
        break;
      case "M":
      case "MM":
        arr[1] = value - 1;
        break;
      case "d":
      case "dd":
        arr[2] = value;
        break;
      case "h":
      case "hh":
        arr[3] = value;
        break;
      case "m":
      case "mm":
        arr[4] = value;
        break;
      case "s":
      case "ss":
        arr[5] = value;
        break;
      case "S":
      case "SS":
      case "SSS":
        arr[6] = value;
        break;
    }
  }
}
/**
 * innerParse
 * @param str
 * @param format
 * @returns {*}
 */
function innerParse(str, format) {
  if (utils.isString(format)) {
    //            if (str.length !== format.length) {
    //                return;
    //            }

    var arr = this.getDateArray(str, format);
    if (!arr) {
      return;
    }

    var year = arr[0] * 1,
      month = arr[1] * 1,
      date = (arr[2] || 1) * 1,
      hours = (arr[3] || 0) * 1,
      minutes = (arr[4] || 0) * 1,
      seconds = (arr[5] || 0) * 1,
      milliseconds = (arr[6] || 0) * 1;
    var maxDateValues = dateCfg.maxDateValues
    if (isNaN(year) || year < 0 || year > maxDateValues.YEAR ||
      isNaN(month) || month < 0 || month > maxDateValues.MONTH ||
      isNaN(date) || date < 0 || date > maxDateValues.DATE ||
      isNaN(hours) || hours < 0 || hours > maxDateValues.HOUR ||
      isNaN(minutes) || minutes < 0 || minutes > maxDateValues.MINUTE ||
      isNaN(seconds) || seconds < 0 || seconds > maxDateValues.SECOND ||
      isNaN(milliseconds) || milliseconds < 0 || milliseconds > maxDateValues.MILLISECOND) {
      return;
    }

    var daysInMonths = dateCfg.daysInMonths[month];
    if (isLeapYear(year) && month === 1) {
      daysInMonths += 1;
    }

    if (date <= daysInMonths) {
      return new Date(year, month, date, hours, minutes, seconds, milliseconds);
    }
  } else {
    return parseDate(str);
  }
}

function isLeapYear(year) {
  return (year % 400) === 0 || ((year % 4) === 0 && (year % 100) !== 0);
}



// WEBPACK FOOTER //
// ./src/utils/dateUtils.js